import { l } from '../lib/imports'
import { jobLogger } from './jobLogger-sidecar'
import { getRegisteredTask, IJob, ITask } from './jobs'
import { runTask_build } from './taskBuild'
import { runTask_constructHull } from './taskConstructHull'
import { runTaskConsumeCargo } from './taskConsumeCargo'
import { runTask_custom } from './taskCustom'
import { runTask_debuild } from './taskDebuild'
import { runTask_deconstructHull } from './taskDeconstructHull'
import { runTaskDeliverCargo } from './taskDeliverCargo'
import { runTask_enterShip } from './taskEnterShip'
import { runTask_exitShip } from './taskExitShip'
import { runTaskFetchCargo } from './taskFetchCargo'
import { runTask_goToMachine } from './taskGoToMachine'
import { runTask_mine } from './taskMine'
import { runTask_moveTo } from './taskMoveTo'
import { runTask_placeInEmptySpace } from './taskPlaceInEmptySpace'
import { runTask_putOnSuit } from './taskPutOnSuit'
import { runTask_takeOffSuit } from './taskTakeOffSuit'

export function advanceTask(job: IJob) {
  let isFailed = l.find(job.tasks, (c) => c.isFailed)

  if (isFailed) {
    jobLogger.failJob(job, 'task failed')
    return
  }

  let task = l.find(job.tasks, (c) => !c.isComplete && !c.isFailed)
  if (!task) {
    job.isComplete = true
    return
  }
  advanceTask2(job, task)
}

export function advanceTask2(job: IJob, task: ITask) {
  if (task.type === 'custom') {
    runTask_custom(job, task)
    return
  }
  if (task.type === 'fetch-cargo') {
    runTaskFetchCargo(job, task)
    return
  }
  if (task.type === 'deliver-cargo') {
    runTaskDeliverCargo(job, task)
    return
  }

  if (task.type === 'consume-cargo') {
    runTaskConsumeCargo(job, task)
    return
  }
  if (task.type === 'place-in-empty-space') {
    runTask_placeInEmptySpace(job, task)
    return
  }

  if (task.type === 'put-on-suit') {
    runTask_putOnSuit(job, task)
    return
  }

  if (task.type === 'take-off-suit') {
    runTask_takeOffSuit(job, task)
    return
  }
  if (task.type === 'move-to') {
    runTask_moveTo(job, task)
    return
  }

  if (task.type === 'exit-ship') {
    runTask_exitShip(job, task)
    return
  }
  if (task.type === 'enter-ship') {
    runTask_enterShip(job, task)
    return
  }
  if (task.type === 'mine') {
    runTask_mine(job, task)
    return
  }
  if (task.type === 'deconstruct-hull') {
    runTask_deconstructHull(job, task)
    return
  }
  if (task.type === 'construct-hull') {
    runTask_constructHull(job, task)
    return
  }
  if (task.type === 'build') {
    runTask_build(job, task)
    return
  }
  if (task.type === 'debuild') {
    runTask_debuild(job, task)
    return
  }
  if (task.type === 'go-to-machine') {
    runTask_goToMachine(job, task)
    return
  }

  let action = getRegisteredTask(task.type)
  action(job, task)

  // throw new Error('unregistered task type ' + task.type)
}
